export const SELECT_REGULATION_MODES = "SELECT_REGULATION_MODES";
export const ADD_REGULATION_MODE = "ADD_REGULATION_MODE";
export const CLEAR_REGULATION_MODES = "CLEAR_REGULATION_MODES";
export const INIT_REGULATION_MODES = "INIT_REGULATION_MODES";
export const EMPTY = "EMPTY";
